/**
 * LO QUE SE LEE DE UN MENSAJE EN UNA FILA (14-10, BAJ-09).
 *
 * La bandeja del equipo pintaba solo `content`, y un mensaje que es una imagen sola no tiene
 * texto: la fila quedaba con el nombre, la hora y nada más. Se dice lo que es, como hace el
 * aviso de la campana ("Te ha enviado una imagen", `backend/routes/messages.py`).
 */
export const vistaPreviaDelMensaje = (mensaje) => {
    const texto = String(mensaje?.content || '').trim();
    if (texto) return texto;
    return mensaje?.adjunto ? 'Imagen' : '';
};
